import * as React from "react";
import { useQuery } from "react-query";

import { SystemApi, SystemInfoDto } from "../api";
import { useApiService } from "../hooks";

interface IGlobalDataContext {
  systemInfo?: SystemInfoDto;
  appVersion: string;
  shortVersion: string;
  backendNotReacheable: boolean;
  loading: boolean;
  retry: () => void;
}

const GlobalDataContext = React.createContext<IGlobalDataContext>(null!);

interface IGlobalDataProviderProps {
  children: React.ReactNode;
}

export const GlobalDataProvider: React.FunctionComponent<
  IGlobalDataProviderProps
> = ({ children }) => {
  const systemApi = useApiService(SystemApi);

  const fetchGlobalData = React.useCallback(async () => {
    const systemInfo = await systemApi.get();
    return { systemInfo };
  }, [systemApi]);

  const {
    data: globalData,
    isFetching: globalDataLoading,
    error,
    refetch,
  } = useQuery("globaldata", fetchGlobalData);

  const appVersion = React.useMemo(() => {
    if (globalData && globalData?.systemInfo?.applicationVersion) {
      console.log(
        "My Via Pro Version " + globalData?.systemInfo?.applicationVersion
      );
      return globalData?.systemInfo?.applicationVersion.split(".Branch")[0];
    } else {
      return "";
    }
  }, [globalData]);

  const backendNotReacheable = React.useMemo(
    () => globalDataLoading || !!error,
    [error, globalDataLoading]
  );

  return (
    <GlobalDataContext.Provider
      value={{
        systemInfo: globalData?.systemInfo,
        loading: globalDataLoading,
        backendNotReacheable,
        appVersion,
        retry: refetch,
        shortVersion: appVersion?.split("+")[0],
      }}
    >
      {children}
    </GlobalDataContext.Provider>
  );
};

export const useGlobalData = () => React.useContext(GlobalDataContext);
